import { type ForwardedRef, forwardRef } from 'react';

import { type VBaseInputProps } from '../VBaseInput';
import VInputTextareaWrapper from '../VInput/VInputTextareaWrapper';
import type { ValueWithLabel } from '../type';
import VInnerToggleButtonGroup from './VInnerToggleButtonGroup';
import type { VInnerToggleButtonGroupProps } from './type';

const VToggleButtonGroup = forwardRef(
  <T extends ValueWithLabel>(
    {
      className,
      comment,
      disabled,
      fluid,
      id,
      label,
      required,
      style,
      ...chipGroupProps
    }: VInnerToggleButtonGroupProps<T> & VBaseInputProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const baseInputProps = {
      className,
      comment,
      disabled,
      fluid,
      id,
      label,
      required,
      style,
    };

    return (
      <VInputTextareaWrapper {...baseInputProps}>
        <VInnerToggleButtonGroup
          ref={ref}
          {...chipGroupProps}
          disabled={disabled}
        />
      </VInputTextareaWrapper>
    );
  },
);

export default VToggleButtonGroup;
